import { InformationCircleIcon } from '@heroicons/react/20/solid';
import { useProductPricesSub } from '../../hooks/useProductPricesSub';
import { useTpSlError } from '../../hooks/useSlTpHooks';

export interface TpSlErrorUiProps {
  error: string | null;
  hideError?: boolean;
}

export const TpSlErrorUi: React.FC<TpSlErrorUiProps> = ({ error, hideError = false }) => {
  if (hideError || !error) return null;

  return (
    <p className="flex items-center gap-1 text-3xs text-contentRed" role="alert">
      <InformationCircleIcon width={16} height={16} className="shrink-0" />
      {error}
    </p>
  );
};

export const TpSlError = ({
  stopLossPrice,
  takeProfitPrice,
  side,
  productId,
  tpOrSl,
  hideError = false,
}: {
  stopLossPrice: bigint | undefined;
  takeProfitPrice: bigint | undefined;
  side: 'long' | 'short';
  productId: string;
  tpOrSl: 'tp' | 'sl';
  hideError?: boolean;
}) => {
  const { data: pricesByProductId } = useProductPricesSub();

  const oraclePrice = pricesByProductId?.[productId]?.oraclePrice;
  const { takeProfitError, stopLossError } = useTpSlError({
    takeProfitPrice,
    stopLossPrice,
    oraclePrice,
    side,
  });

  const error = tpOrSl === 'tp' ? takeProfitError : stopLossError;

  return <TpSlErrorUi error={error} hideError={hideError} />;
};
